import quikTradeDashboard from '../../../../assets/img/landing/qt-dashboard.png';
import accountsDashboard from '../../../../assets/img/landing/accounts-dashboard.png';
import strategyView from '../../../../assets/img/landing/strategy-view.png';
import strategyCreation from '../../../../assets/img/landing/create-strategy.png';
import signalDashboard from '../../../../assets/img/landing/algo-signals.png';
import executionTerminal from '../../../../assets/img/landing/qt-terminal.png';
import darkMode from '../../../../assets/img/landing/qt-terminal-dark.png';
import terminalConfig from '../../../../assets/img/landing/qt-config.png';
import riskSettings from '../../../../assets/img/landing/risk-settings.png';
import optionChain from '../../../../assets/img/landing/option-chain.png';
import brokerConfig from '../../../../assets/img/landing/broker-config.png';
import stratAdjustment from '../../../../assets/img/landing/strategy-adjustment.png';
import scalperTerminal from '../../../../assets/img/landing/scalper-terminal.png';
// import positionAdjustment from '../../../../assets/img/landing/position-adjustment.png';
import activityLogs from '../../../../assets/img/landing/activity-logs.png';

export const quiktradeFeatures = [
  {
    id: "qt-dashboard",
    title: "QuikTrade Dashboard",
    description:
      "Comprehensive dashboard for all your trading (both Algo & Discretionary/Manual)",
    images: [
      {
        file: quikTradeDashboard,
      },
    ],
  },
  {
    id: "accounts-dashboard",
    title: "Accounts Dashboard",
    description:
      "Provides account wise segregation of your algo strategies",
    images: [
      {
        file: accountsDashboard,
      },
    ],
  },
  {
    id: "strategy-view",
    title: "Strategy View",
    description:
      "Provides Strategy wise profit & loss, linked broker accounts, linked signals, etc in a single place.",
    images: [
      {
        file: strategyView,
      },
    ],
  },
  {
    id: "strategy-creation",
    title: "Strategy Creation Wizard",
    description:
      "This is where you can create simple to very complex algo strategies.",
    images: [
      {
        file: strategyCreation,
      },
    ],
  },
  {
    id: "signal-dashboard",
    title: "Signal Dashboard",
    description:
      "Provides a comprehensive view of all of your created signals, linked strategies, linked broker accounts & execution multiplier and cumulative signal logs for all incoming signals to the platform.",
    images: [
      {
        file: signalDashboard,
      },
    ],
  },
  
  {
    id: "broker-config",
    title: "Broker Configuration",
    description:
      "You can link all of your broker accounts here, we support 200+ brokers, including all of the India’s top brokers.",
    images: [
      {
        file: brokerConfig,
      },
    ],
  },
  
  {
    id: "execution-terminal",
    title: "Execution Terminal",
    description:
      "This is first of a kind Trading Terminal that helps you execute your Manual / Discretionary Trades with just 1 click. Yes, 1 click for multi leg option orders, (like straddle buy/sell, strangles with hedges) 1 click for strategy/position adjustments and multi-level risk management. Scalper mode for super-fast trades.",
    images: [
      {
        file: executionTerminal,
      },
    ],
  },
  
  {
    id: "dark-mode",
    title: "Dark mode available across the platform",
    description:
      "Enjoy a comfortable viewing experience with our dark mode toggle across all sections of the platform.",
    images: [
      {
        file: darkMode,
      },
    ],
  },
  
  {
    id: "strat-adjustment",
    title: "Strategy adjustment buttons",
    description:
      "Exit only Calls, Exit only Puts, Exit All Positions\nMove multiple positions AWAY from ATM (think of converting straddles to strangles)\nMove multiple positions TOWARDS ATM (think of converting strangles to straddles or converge towards ATM)\nMove UP all the positions or Move DOWN all the positions.",
    images: [
      {
        file: stratAdjustment,
      },
    ],
  },
  
  {
    id: "terminal-config",
    title: "QuikTrade Terminal Configuration",
    description:"",
        images: [
      {
        file: terminalConfig,
      },
    ],
  },
  {
    id: "order-entry-panel",
    title: "Order Entry Panel",
    description: "Directly execute orders from straddle chain, strangle chain or custom / ready made strategies using 1 click. Select Hedge automatically based on Premium, Delta and Distance from ATM.",
    images: [
      {
        file: optionChain,
      },
    ],
  },
  {
    id: "scalper-terminal",
    title: "Scalper Terminal",
    description: "Execute orders right from your keyboard using QuikKeys (use arrow keys)",
    images: [
      {
        file: scalperTerminal,
      },
    ],
  },
  // {
  //   id: "position-adjustment",
  //   title: "Position Level Adjustments",
  //   description: "1 click to Add / Exit or Reverse a position. 1 click to adjust the positions either by MOVING AWAY or TOWARDS ATM strike to Risk ON or OFF the position.",
  //   images: [
  //     {
  //       file: positionAdjustment,
  //     },
  //   ],
  // },
  {
    id: "risk-settings",
    title: "Risk Settings Panel",
    description: "Configure Risk settings such as Stoploss, Target, Trailing Stoploss and Profit Locking and Trailing parameters either by Price (combined Premium in case of a strategy), Profit and Loss values.",
    images: [
      {
        file: riskSettings,
      },
    ],
  },
  
  
  {
    id: "position-monitoring",
    title: "Activity Logs",
    description: "Every button click, every activity is tracked through logs.",
    images: [
      {
        file: activityLogs,
      },
    ],
  },
  
]

